var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.293 8.29302C4.48053 8.10555 4.73484 8.00023 5 8.00023C5.26516 8.00023 5.51947 8.10555 5.707 8.29302L12 14.586L18.293 8.29302C18.3852 8.19751 18.4956 8.12133 18.6176 8.06892C18.7396 8.01651 18.8708 7.98892 19.0036 7.98777C19.1364 7.98662 19.2681 8.01192 19.391 8.0622C19.5138 8.11248 19.6255 8.18673 19.7194 8.28063C19.8133 8.37452 19.8875 8.48617 19.9378 8.60907C19.9881 8.73196 20.0134 8.86364 20.0123 8.99642C20.0111 9.1292 19.9835 9.26042 19.9311 9.38242C19.8787 9.50443 19.8025 9.61477 19.707 9.70702L12.707 16.707C12.5195 16.8945 12.2652 16.9998 12 16.9998C11.7348 16.9998 11.4805 16.8945 11.293 16.707L4.293 9.70702C4.10553 9.51949 4.00021 9.26518 4.00021 9.00002C4.00021 8.73486 4.10553 8.48055 4.293 8.29302V8.29302Z",
    fill: "#94A3B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/ArrowDownIcon.ff9ca24a737e38aae35b47bfcf554134.svg";
export { ForwardRef as ReactComponent };